/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnShared } from './en-shared';
 /**
 *
 *
 * @export
 * @interface CreateProtocolDto
 */
export interface CreateProtocolDto {

    /**
     * @type {string}
     * @memberof CreateProtocolDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof CreateProtocolDto
     */
    description?: string | null;

    /**
     * @type {EnShared}
     * @memberof CreateProtocolDto
     */
    shared?: EnShared;
}
